import type { ReactNode } from "react";

interface BuyerLike {
  fullName: string | null;
  title: string | null;
  prospectCompany?: { name: string } | null;
}

interface Props {
  buyer: BuyerLike;
  leading?: ReactNode;
}

export function BuyerCard({ buyer, leading }: Props) {
  const buyerName = buyer.fullName ?? "Buyer pending import";
  const companyName = buyer.prospectCompany?.name ?? "—";

  return (
    <div className="flex items-center gap-2 text-sm">
      {leading}
      <span className="font-medium text-text-primary">{buyerName}</span>
      <span className="text-text-muted">·</span>
      <span className="text-text-secondary">{buyer.title ?? "title unknown"}</span>
      <span className="text-text-muted">·</span>
      <span className="text-text-secondary">{companyName}</span>
    </div>
  );
}
